@use 'sass:math';

@import '../../scss/utility';
@import './header.utility';

@import './language-menu.scss';
@import './nav.scss';

wb-header {
  display: block;
  background: var(--wb-black);
  z-index: $z-index-header;
  max-width: 100%;
  overflow-x: hidden;

  .wb-header__content-width {
    @include wb-content-width;
    position: relative;
  }

  .wb-header__logo {
    z-index: 1;
  }

  @include breakpoint-to(mq4) {
    .wb-header__logo {
      position: absolute;
      left: 50%;
    }

    .wb-header__claim-wrapper {
      display: none;
    }

    .wb-header__nav-container {
      display: flex;
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      right: 0;
      top: 0;
      justify-content: space-between;
      align-items: center;
    }
  }

  // MOBILE
  @include breakpoint-to(mq2) {
    .wb-header__logo-container {
      height: $_header-height-small;
    }

    .wb-header__logo {
      margin-left: math.div(-$_header-height-small, 2);
      padding: math.div($_header-height-small - $_logo-size-small, 2);
      height: $_header-height-small;
      width: $_header-height-small;
    }

    .wb-header__star {
      width: $_logo-size-small;
      height: $_logo-size-small;
    }
  }

  // TABLET
  @include breakpoint-between(mq3, mq5) {
    .wb-header__logo-container {
      height: $_header-height-large;
    }

    .wb-header__logo {
      margin-left: math.div(-$_header-height-large, 2);
      padding: math.div($_header-height-large - $_logo-size-large, 2);
      height: $_header-height-large;
      width: $_header-height-large;
    }

    .wb-header__star {
      width: $_logo-size-large;
      height: $_logo-size-large;
    }
  }

  // DESKTOP
  @include breakpoint-from(mq5) {
    .wb-header__logo-container {
      height: $_header-height-large;
    }

    .wb-header__logo {
      line-height: 0;
      position: absolute;
      width: $_logo-width-desktop;
      left: 0;
      top: math.div($_header-height-large - $_logo-size-large, 2);
    }

    .wb-header__star {
      width: $_logo-size-large;
      height: $_logo-size-large;
    }

    .wb-header__claim-wrapper {
      display: block;
      position: absolute;
      right: 0;
      bottom: 2px;
    }

    .wb-header__nav-container {
      display: block;
    }

    .wb-header__claim {
      width: 112px;
      color: var(--wb-white);

      &--en {
        display: block;
      }

      &--de {
        display: none;
        padding-bottom: 2px;
      }
    }
  }

  .wb-header__claim--blank {
    display: none;
    margin-bottom: 3px; // make sure the claim is positioned at the lowest point of the stars inner circle
  }

  &[hide-claim] {
    .wb-header__claim--de,
    .wb-header__claim--en {
      display: none;
    }

    .wb-header__claim--blank {
      display: block;
    }
  }
}

[lang='de'] {
  .wb-header__claim--de {
    display: block;
  }

  .wb-header__claim--en {
    display: none;
  }
}
